<qai-assignment-card
  [title]="title"
  [kind]="kind"
  [statusBadge]="statusInfo"
  [dueDate]="formattedDueDate"
  [dueDateBadge]="dueDateInfo"
  [translatedLabel]="'dashboard.' + assignment.moduleAssignmentDTO.moduleAssignmentType | transloco"
  [ribbonIcon]="ribbonIcon"
  >
  <a
    qai-button
    kind="primary"
    size="small"
    data_testId="view-assignment-button"
    qaiSlot="action"
    *ngIf="assignmentUrl"
    [href]="isViewActionDisabled ? '' : assignmentUrl"
    [routerLink]="isViewActionDisabled ? null : routeCommands"
    [queryParams]="isViewActionDisabled ? null : getQueryParams()"
    [attr.aria-label]="ariaLabel"
    [attr.aria-disabled]="isViewActionDisabled"
    [class.view-action-disabled]="isViewActionDisabled"
    (click)="onViewActionClick($event)"
  >
    <span>{{ ctaLabelKey | transloco }}</span>
  </a>
</qai-assignment-card>
